import React from 'react';
import { loadData as loadDataLatest } from './InboxPage.duck';
import InboxPageNew from './InboxPageNew/InboxPageNew';
import InboxPageLegacy from './InboxPageLegacy/InboxPageLegacy';

// For now we render the new inbox UI but keep legacy copy available for future switch/experiments
// Both routes share the same path; the transaction row click routing will decide transaction page.
const InboxPageRouter = props => {
  const useLegacy = false;
  return useLegacy ? <InboxPageLegacy {...props} /> : <InboxPageNew {...props} />;
};

// Pass through latest loader; legacy uses different filtering but router keeps URL stable
export const loadData = (params, search) => (dispatch, getState, sdk) => {
  return dispatch(loadDataLatest(params, search));
};

export default InboxPageRouter;
